module.exports = __webpack_public_path__ + "static/media/ex21.d7803c45.jpg";